<template>
  <div class="elementLengths" :key="`tab_content_2` + $store.state.calculatorData.calculatorPages[2].disabled">
    <div class="row">
      <div class="col-md-6">
        <h2>{{ $t(`elementLengths.title`)}}</h2>
      </div>
      <div class="col-md-6 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>
    <b-button @click="explanationClick()" v-b-toggle.explanation-content-elementLengths variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-elementLengths" class="explanation-content">
      <b-card>
        <p v-html="$t('elementLengths.infoText')"></p>
      </b-card>
    </b-collapse>
    <div class="row" :key="templateKey">
      <div class="technical-draw col-md-5 d-none d-md-block align-self-center">
        <TechnicalDrawing step="elementLengths" :type="`elementlengths_`+elementForm" />
      </div>
      <div class="col-md-7">

        <div class="technical-draw d-md-none">
          <TechnicalDrawing step="elementLengths" :type="`elementlengths_`+elementForm" />
        </div>
        <div v-if="elementForm !== ''">
          <StoSlider name="a" tab="elementLengths" />
          <StoSlider name="a1" tab="elementLengths" />
          <StoSlider name="a2" tab="elementLengths" />

          <div class="slider-wrapper input-container highlight-box calculated-box">
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`elementLengths.fullLength`)"></span>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="totalLength" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="totalLength" class="slider-input disabled" disabled="disabled"> mm
              </div>
            </div>
          </div>

        </div>
        <div class="info-wrapper">
          <div v-if="$store.state.calculatorData.warnings.elementLengths">
            <p v-if="$store.state.calculatorData.warnings.elementLengths.totalLengthOfOneElement && ((elementForm == 'jak') || (elementForm == 'jas')) " class="info" v-html="$t('elementLengths.warningLengthJakJas')"></p>
            <p v-else-if="$store.state.calculatorData.warnings.elementLengths.totalLengthOfOneElement" class="info" v-html="$tc('elementLengths.warningLength',totalLength, {totalLength: totalLengthOfOneElement} )"></p>
            <p v-if="$store.state.calculatorData.warnings.elementLengths.totalElements" class="info" v-html="$tc('elementLengths.warningTotalElements',totalElements, {totalElements: totalElements} )"></p>
          </div>
        </div>
      </div>
    </div>
    <StepNavi thisPage="3" :key="`navi_tab3_`+ $store.state.calculatorData.calculatorPages[3].disabled"/>
  </div>
</template>

<script>
import StoSlider from './StoSlider.vue'
import TechnicalDrawing from './TechnicalDrawing.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ElementLengths',
  components: {
    StoSlider,
    TechnicalDrawing,
    StepNavi
  },
  data () {
    return {
      min: 0,
      max: 0,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'totalLength',
      'totalLengthOfOneElement',
      'totalElements',
      'disabledStatusTab2',
      'disabledStatusTab3',
      'elementForm'
    ]),
    templateKey: function () {
      let updateString = 'elementLengths-templateKey'
      updateString += '_pageDisabled-' + this.$store.state.calculatorData.calculatorPages[2].disabled
      updateString += 'pageError-' + this.$store.getters.pageError('elementLengths')
      return updateString
    },
    naviKey: function () {
      let updateString = 'elementLengths-naviKey'
      updateString += '_pageDisabled-' + this.$store.state.calculatorData.calculatorPages[3].disabled
      updateString += 'pageError-' + this.$store.getters.pageError('elementLengths')
      return updateString
    },
    lengthWarning: function () {
      let calulation = Math.ceil(this.$store.state.calculatorData.currentOrder.totalLength / this.$store.state.calculatorData.currentOrder.totalLengthOfOneElement)
      return calulation
    }
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'elementLengths'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- elementLengths rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
